import { Maybe } from 'graphql/jsutils/Maybe';

const validTypes = [
  'countdowndeck',
  'ctadeck',
  'flexdeck',
  'focusdeck',
  'herodeck',
  'live_product_deck',
  'oneimagedeck',
  'text_deck',
  'podcastdeck',
  'promodeck',
  'mini_promotion_banner',
  'promotion_banner',
  'promotion_banner_commercial_permission',
  'uspdeck',
  'vimeo_promo_deck',
  'voucherdeck',
] as const;

type DeckTypes = (typeof validTypes)[number];
export type CommercialDeck = {
  position?: Maybe<number>;
  id: string;
};

type PrismicDeckExperiment = {
  type: DeckTypes;
  id: string;
  position: number;
  displayRules: {
    displayNonsubscriber: boolean;
    displayB2b: boolean;
    displayDtc: boolean;
    displayPartner: boolean;
  };
  overrides: Record<string, string> | undefined;
};

const defaultDisplayRules = {
  displayNonsubscriber: false,
  displayB2b: false,
  displayDtc: false,
  displayPartner: false,
};

function isPrismicDeckExperiment(experiment: any): experiment is PrismicDeckExperiment {
  const res =
    experiment.type &&
    typeof experiment.type === 'string' &&
    validTypes.includes(experiment.type) &&
    experiment.id &&
    typeof experiment.id === 'string' &&
    experiment.position !== undefined &&
    typeof experiment.position === 'number';

  return res;
}

export function mapTargetPrismicExperiments(targetExperiments: any[]) {
  return appendGlobalIdList((targetExperiments || []).filter(isPrismicDeckExperiment));
}

function appendGlobalIdList(targetExperiments: PrismicDeckExperiment[]) {
  return targetExperiments.map(experiment => ({
    ...experiment,
    displayRules: {
      ...defaultDisplayRules,
      ...(experiment.displayRules ?? {}),
    },
    prismicId: btoa([experiment.type, experiment.id].join(':')),
  }));
}
